module.exports = __webpack_public_path__ + "static/favicon.93bb331c.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 1224
// module chunks = 168707334958949